import ProcessFlowCallToAction from "~/models/processFlows/callToActions/processFlowCallToAction";
import {IProcessFlowCallToActionNewFormSubmission} from "~/interfaces/processFlowInterfaces";
import {CallToActionType} from "~/enums/processFlows/callToActionType";
import Form, {IForm} from "../../../../formability/form_builder/models/form";


export default class NewFormSubmissionCallToAction extends ProcessFlowCallToAction implements IProcessFlowCallToActionNewFormSubmission {
  action_type: CallToActionType.NewFormSubmission
  form_id: string

  constructor(protected _rootName: string, options: any = {}) {
    super(_rootName, options)
    this.defineProperty("button_label", "View Submission")
    this.defineProperty('form_id', null)
  }

  get form(): IForm {
    if (!this.form_id) return

    return Form.repo.findById(this.form_id)
  }

  get isValid(): boolean {
    return (!this.buttonLabelRequired || Boolean(this.button_label)) &&
      Boolean(this.form_id)
  }
}